import { useTranslation } from 'react-i18next';

import { OfflineCardAnim } from '../../molecules/Animations';
import { MplModal } from '../MplModal';

export default function OfflineModal() {
	const { t } = useTranslation('logIn');

	return (
		<MplModal
			open
			icon={<OfflineCardAnim />}
			testId="OfflineModal-MplModal"
			title={t('modal.offline.title')}
			content={t('modal.offline.text')}
		/>
	);
}
